import { render, staticRenderFns } from "./StatCalcCard.vue?vue&type=template&id=391a3f08&scoped=true&"
import script from "./StatCalcCard.vue?vue&type=script&lang=ts&"
export * from "./StatCalcCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatCalcCard.vue?vue&type=style&index=0&id=391a3f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a3f08",
  null
  
)

export default component.exports